import React from "react";

export default function App() {
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-6">
      <header className="text-center space-y-2">
        <h1 className="text-4xl font-bold">Hotel Mist</h1>
        <p className="text-lg">Comfortable, Affordable, Reliable</p>
      </header>

      <section className="space-y-1 text-center">
        <p>
          Phone/WhatsApp:{" "}
          <a href="tel:6283287239" className="text-blue-600">
            6283287239
          </a>
        </p>
        <p>
          Email:{" "}
          <a href="mailto:hotelm1@gmail.com" className="text-blue-600">
            hotelm1@gmail.com
          </a>
        </p>
        <p>Address: Near Century Public School, Nayagaon, Chandigarh</p>
        <p>
          Instagram:{" "}
          <a
            href="https://www.instagram.com/chandigarhhotel?igsh=MWNpN3M1aXlnNWd5OQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600"
          >
            @chandigarhhotel
          </a>
        </p>
      </section>
    </div>
  );
}
